export default __webpack_public_path__ + "static/media/product5.a231ad78.webp";